import PropTypes from 'prop-types';
import { isEmpty, startCase } from 'lodash';
import React from 'react';
import style from './StringifyTradePlan.module.css';


export const StringifyTradePlan = ({ tradePlan }) => {
  const resultArray = [];

  const recursiveIteration = (obj, arr, layer) => {
    const layerString = `layer${layer}`;
    const objArray = Object.entries(obj);
    objArray.forEach((pair, index) => {
      
      if (pair[0] === 'deepCopyExitTactics' || pair[1] === undefined || pair[1] === null) return;
      const key = startCase(pair[0]);
      if (typeof pair[1] === 'object') {
        if (isEmpty(pair[1])) return;
        arr.push(
          <p
            key={key + index}
            fontWeight={700}
            className={style[layerString]}
          >{`${key}:`}</p>
        );
        recursiveIteration(pair[1], resultArray, layer + 1);
      } else {
        arr.push(
          <p
            key={key + pair[1] + index}
            fontWeight={700}
            className={style[layerString]}
          >{`${key}: ${pair[1]}`}</p>
        );
      }
    });
  };

  recursiveIteration(tradePlan, resultArray, 1);

  return <div>{resultArray}</div>;
};

StringifyTradePlan.propTypes = {
  tradePlan: PropTypes.object
};

